import React from 'react';
import { createValidationErrors, Textarea, Validation } from 'ui';
import { Tag } from 'app/components/tag';
import { Value } from 'app/types-shared';

import { maxDescriptionLength, maxLongDescriptionLength } from '../constants';
import { CodeDescriptionSearchData } from '../types-store';
import { CodeListItem } from './types';
import { getCodeDataId } from './get-code-data-id';
import { itemPropsAreEqual } from './item-props-are-equal';

import styles from './code-description-tile.scss';

const getDescription = (value: Value) => value ? value.d : undefined;

export const CodeDescriptionTile: CodeListItem = React.memo(({
  codeData = {} as CodeDescriptionSearchData,
  description, longDescription,
  modifyDescription, modifyLongDescription, edited, displayLongDescription,
  descValidationMessages, longDescValidationMessages, translation
}) => {

  const descHasErrors = (descValidationMessages?.length ?? 0) > 0;
  const descValidation = descHasErrors ? createValidationErrors(descValidationMessages) : undefined;

  const longDescHasErrors = (longDescValidationMessages?.length ?? 0) > 0;
  const longDescValidation = longDescHasErrors ? createValidationErrors(longDescValidationMessages) : undefined;

  return <div className={descHasErrors || longDescHasErrors
    ? `has-danger ${styles.error}`
    : edited ? styles.edited : undefined}>
    <div>
      <div className={styles.id}>#{codeData.id}</div>
      <Tag className={styles.language}>{getDescription(codeData.language)}</Tag>
      <div className={styles.textset}>{getDescription(codeData.codetable)}</div>
    </div>
    <Textarea
      className={undefined}
      componentId={`description_${getCodeDataId(codeData)}`}
      label={{ text: translation.description }}
      value={description}
      onChange={modifyDescription}
      maxLength={maxDescriptionLength}
      wait={500} />
    {descHasErrors && <Validation level={descValidation.level} messages={descValidation.messages} />}
    {displayLongDescription && <>
      <Textarea
        className={undefined}
        componentId={`longDescription_${getCodeDataId(codeData)}`}
        label={{ text: translation.long_description }}
        value={longDescription}
        onChange={modifyLongDescription}
        maxLength={maxLongDescriptionLength}
        wait={500} />
      {longDescHasErrors && <Validation level={longDescValidation.level} messages={longDescValidation.messages} />}
    </>}
  </div>;
}, itemPropsAreEqual);
